(function () {
  const DURATION_MS = 300;

  const MINUS_SVG = `
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16" fill="currentColor" class="w-4 h-4">
      <path d="M3.75 7.25a.75.75 0 0 0 0 1.5h8.5a.75.75 0 0 0 0-1.5h-8.5Z" />
    </svg>`;
  const PLUS_SVG = `
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16" fill="currentColor" class="w-4 h-4">
      <path d="M8.75 3.75a.75.75 0 0 0-1.5 0v3.5h-3.5a.75.75 0 0 0 0 1.5h3.5v3.5a.75.75 0 0 0 1.5 0v-3.5h3.5a.75.75 0 0 0 0-1.5h-3.5v-3.5Z" />
    </svg>`;

  function getParts(index) {
    const panel = document.getElementById(`content-${index}`);
    const icon  = document.getElementById(`icon-${index}`);
    const inner = panel ? panel.querySelector('.accordion-inner') : null;
    return { panel, icon, inner };
  }

  // Observe inner size; when it changes, sync the parent's max-height
  const ro = new ResizeObserver((entries) => {
    for (const entry of entries) {
      const inner = entry.target;
      const panel = inner.closest('[id^="content-"]');
      if (!panel) continue;
      if (!panel.classList.contains('open')) continue;

      const h = inner.scrollHeight;
      // During/after reflows/wraps, always match the new height
      panel.style.maxHeight = h + 'px';
    }
  });

  function openPanel(panel, inner) {
    if (!inner) return;
    panel.classList.add('open');
    panel.style.overflow = 'hidden';
    panel.style.transition = `max-height ${DURATION_MS}ms ease-in-out`;
    // set start height then animate to content height
    panel.style.maxHeight = inner.scrollHeight + 'px';
    ro.observe(inner);
  }

  function closePanel(panel, inner) {
    if (inner) ro.unobserve(inner);
    panel.style.transition = `max-height ${DURATION_MS}ms ease-in-out`;
    panel.style.maxHeight = '0';
    panel.classList.remove('open');
  }

  function closeOthers(exceptIndex) {
    const allPanels = document.querySelectorAll('[id^="content-"]');
    const allIcons  = document.querySelectorAll('[id^="icon-"]');
    allPanels.forEach((p, i) => {
      if (i + 1 === exceptIndex) return;
      const inner = p.querySelector('.accordion-inner');
      if (p.classList.contains('open')) {
        closePanel(p, inner);
        const icon = allIcons[i];
        if (icon) icon.innerHTML = PLUS_SVG;
      }
    });
  }

  function toggleAccordion(index) {
    const { panel, icon, inner } = getParts(index);
    if (!panel || !icon || !inner) return;

    const isOpen = panel.classList.contains('open');
    closeOthers(index);

    if (isOpen) {
      closePanel(panel, inner);
      icon.innerHTML = PLUS_SVG;
    } else {
      openPanel(panel, inner);
      icon.innerHTML = MINUS_SVG;
    }
  }

  // Optional: manual refresh if you want to force sync from Angular
  function refreshOpenAccordions() {
    document.querySelectorAll('[id^="content-"].open').forEach(panel => {
      const inner = panel.querySelector('.accordion-inner');
      if (inner) {
        panel.style.maxHeight = inner.scrollHeight + 'px';
      }
    });
  }

  window.toggleAccordion = toggleAccordion;
  window.accordionRefresh = refreshOpenAccordions;
})();

// Disable Ctrl + Mouse Wheel (browser zoom)
window.addEventListener(
  "wheel",
  (e) => {
    if (e.ctrlKey) {
      e.preventDefault();
    }
  },
  { passive: false }
);

// Disable Ctrl + +/- / 0 zoom shortcuts
window.addEventListener("keydown", (e) => {
  if (
    e.ctrlKey &&
    (e.key === "+" || e.key === "-" || e.key === "=" || e.key === "0")
  ) {
    e.preventDefault();
  }
});

// Disable trackpad pinch zoom (Safari/Chrome)
window.addEventListener(
  "gesturestart",
  (e) => e.preventDefault()
);
window.addEventListener(
  "gesturechange",
  (e) => e.preventDefault()
);
window.addEventListener(
  "gestureend",
  (e) => e.preventDefault()
);
